module.exports = __webpack_public_path__ + "img/frame_degree_s_4.fbe27e6b.png";